import React from "react";
import { motion, HTMLMotionProps } from "framer-motion";

export interface AnimatedViewProps extends HTMLMotionProps<"div"> {
  /** Initial state before entry */
  from?: any;
  /** Target state after entry */
  animate?: any;
  /** Transition configuration */
  transition?: any;
  /** Whether to animate on mount */
  animateOnMount?: boolean;
  children?: React.ReactNode;
}

/**
 * Unified AnimatedView for Web using Framer Motion.
 */
export const AnimatedView = ({
  from = { opacity: 0, scale: 0.95 },
  animate = { opacity: 1, scale: 1 },
  transition = { duration: 0.3 },
  children,
  ...props
}: AnimatedViewProps) => {
  return (
    <motion.div
      initial={from}
      animate={animate}
      transition={transition}
      {...(props as any)}
    >
      {children}
    </motion.div>
  );
};
